// extracted by mini-css-extract-plugin
export default {"link":"style--link--3f6a86","icon":"style--icon--4d9590"};